if (!window.Eurus.loadedScript.has('scrolling-promotion.js')) {
  window.Eurus.loadedScript.add('scrolling-promotion.js');

  const registerScrollPromotion = () => {
    Alpine.data('xScrollPromotion', () => ({
        animationFrameId: null,
        window_height: window.innerHeight,
        elementDocumentCenter: null,
        lastTransform: null,
        scrollHandler: null,

        load(el) {
          Array.from(el.getElementsByClassName('el_animate')).forEach((item) => {
            item.classList.add('animate-scroll-banner');
          });
        },

        createObserver(el, rtlCheck = false) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.window_height = window.innerHeight;
                this.elementDocumentCenter =
                  window.scrollY + entry.boundingClientRect.top + entry.boundingClientRect.height / 2;

                if (!this.scrollHandler) {
                  this.scrollHandler = () => this.updateRotation(el, rtlCheck);
                  window.addEventListener('scroll', this.scrollHandler, { passive: true });
                }

                this.updateRotation(el, rtlCheck);
              } else {
                if (this.scrollHandler) {
                  window.removeEventListener('scroll', this.scrollHandler);
                  this.scrollHandler = null;
                }
                if (this.animationFrameId) {
                  cancelAnimationFrame(this.animationFrameId);
                  this.animationFrameId = null;
                }
              }
            });
          }, {
            root: null,
            rootMargin: '300px',
            threshold: 0
          });

          observer.observe(el);
        },

        updateRotation(el, rtlCheck = false) {
          const element = el.firstElementChild;
          if (!element || this.elementDocumentCenter === null || this.animationFrameId) return;

          this.animationFrameId = window.requestAnimationFrame(() => {
            this.animationFrameId = null;
            const elementCenter = this.elementDocumentCenter - window.scrollY;

            if (elementCenter > -200 && elementCenter < this.window_height + 200) {
              let value = Math.max(Math.min((((elementCenter / this.window_height) * 10) - 5), 5), -5);
              if (rtlCheck) value *= -1;

              const transform = `rotate(${value.toFixed(3)}deg) translateX(-20px)`;
              if (transform !== this.lastTransform) {
                element.style.transform = transform;
                this.lastTransform = transform;
              }
            }
          });
        },
    }));
  };

  if (window.Alpine) {
    registerScrollPromotion();
  } else {
    document.addEventListener('alpine:init', registerScrollPromotion, { once: true });
  }
}